import { entityTitle, type Age, type AgeAt, type StateChange, type StoryCtx } from '@dispositio/core';
import { de } from '../i18n/de';

const S = de.states;

/** Was eine Änderung sagt, ohne das Element: „tot“, „in Rom“, „bei Ben“, „verloren“, „Haare: grau“; mit Herkunft „bei Ben (von Clara)“ */
export function changeText(ctx: StoryCtx, c: Pick<StateChange, 'kind' | 'value'> & { from?: string; trait?: string }): string {
  if (c.kind === 'verfassung') return S.condition[c.value ?? ''] ?? String(c.value);
  if (c.kind === 'merkmal') return c.value === null ? S.traitGone(c.trait ?? '') : S.trait(c.trait ?? '', c.value);
  if (c.kind === 'ort') return S.at(c.value ? entityTitle(ctx, c.value) : '?');
  const what = c.value ? S.with(entityTitle(ctx, c.value)) : S.lost;
  return c.from ? S.from(what, entityTitle(ctx, c.from)) : what;
}

/** Eine Änderung als Satz: „Clara – tot“ */
export const changeLine = (ctx: StoryCtx, c: Pick<StateChange, 'entityId' | 'kind' | 'value' | 'from' | 'trait'>): string => `${entityTitle(ctx, c.entityId)} – ${changeText(ctx, c)}`;

/** Ein Alter in Worten (PF 15): „21 Jahre“, „3 Monate“, „12 Tage“, „neugeboren“; im Dativ „mit 21 Jahren“; ungefähr: „etwa 21 Jahre“ */
export function ageText(age: Age, dative = false): string {
  const t =
    age.years >= 1
      ? (dative ? S.yearsDat : S.years)(age.years)
      : age.months >= 1
        ? (dative ? S.monthsDat : S.months)(age.months)
        : age.days >= 1
          ? (dative ? S.daysDat : S.days)(age.days)
          : S.newborn;
  return age.approx && age.years >= 1 ? S.about(t) : t;
}

/** Alter zu einer Szene: „21 Jahre“, „noch nicht geboren“, „tot (mit 54 Jahren)“ */
export function ageAtText(a: AgeAt): string {
  if (a.state === 'unborn') return S.unborn;
  if (a.state === 'dead') return a.age ? `${S.dead} (${S.diedAt(ageText(a.age, true))})` : S.dead;
  return a.age ? ageText(a.age) : S.noAge;
}
